import { cardItems } from '@/mocks/homeData';

const cardImages = [
  'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20film%20production%20set%20with%20traditional%20Chinese%20costumes%20and%20elegant%20set%20design%20in%20warm%20coral%20pink%20and%20golden%20lighting%20cinematic%20documentary%20photography%20style%20with%20soft%20atmosphere&width=640&height=400&seq=card-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20curated%20collection%20of%20classic%20film%20posters%20and%20movie%20memorabilia%20displayed%20on%20a%20warm%20cream%20wall%20with%20soft%20golden%20accent%20lighting%20editorial%20photography%20style%20with%20elegant%20composition&width=640&height=400&seq=card-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20colorful%20anime%20style%20illustration%20of%20various%20characters%20from%20different%20genres%20in%20warm%20peach%20and%20coral%20tones%20vibrant%20yet%20soft%20atmosphere%20with%20whimsical%20floating%20elements%20and%20sparkles&width=640&height=400&seq=card-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20vibrant%20comedy%20variety%20show%20stage%20with%20bright%20colorful%20lighting%20and%20laughter-filled%20atmosphere%20in%20warm%20amber%20and%20coral%20tones%20entertainment%20photography%20with%20dynamic%20energy&width=640&height=400&seq=card-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20beautiful%20Southeast%20Asian%20tropical%20landscape%20with%20traditional%20architecture%20and%20lush%20greenery%20at%20golden%20hour%20in%20warm%20amber%20and%20soft%20peach%20tones%20cinematic%20travel%20photography%20style&width=640&height=400&seq=card-05&orientation=landscape',
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-article-line"></i>
            <span>精选内容</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            精选内容
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            糖心视频编辑精选的优质图文内容与观影指南
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.map((item, idx) => (
            <a
              key={item.id}
              href={item.url}
              className="group rounded-2xl overflow-hidden bg-background-100 hover:ring-2 hover:ring-secondary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[1.6/1] overflow-hidden bg-background-200">
                <img
                  src={cardImages[idx]}
                  alt={`${item.title} - 糖心视频精选内容`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 font-medium backdrop-blur-sm whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
              </div>

              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-400 mb-2">
                  <i className="ri-calendar-line"></i>
                  <span>{item.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}